import React, { useContext } from 'react';
import { SignUp } from 'api';
import SignUpForm from 'forms/signupForm';
import { SignInContext } from 'contexts';
import { useApi } from 'hooks';
import { Process } from 'common';
import { navigate, useQueryParams } from 'hookrouter';

const SignUpPage = () => {
  const [queryParams] = useQueryParams();
  const [signUpStatus, callSignUp] = useApi(SignUp);
  const [, setSignInContext] = useContext(SignInContext);

  const signIn = (data) => {
    // New version of API responds with access token. Use for post sign in process
    if (data.AccessToken) {
      setSignInContext(data.AccessToken);
      navigate('/mortgage/sign-in/post-processing', true, { appId: 'Mortgage', ...queryParams });
    }
    // Maintaining the old behavior for previous API response (no access token was given)
    else {
      navigate('/mortgage/sign-up/success');
    }
  };

  const signUp = (user) => {
    const { firstName, lastName, email, phone, password, password2 } = user;
    // Errors for both steps of sign up in the API (registration and sign in) are caught in this call
    callSignUp(firstName, lastName, email, phone, password, password2).then((data) => data && signIn(data));
  };

  const isLoading = () => signUpStatus.isLoading;

  const error = () => {
    if (signUpStatus.error) return signUpStatus.error;
    return false;
  };

  return (
    <Process error={error} isLoading={isLoading}>
      <SignUpForm signUp={signUp} />
    </Process>
  );
};

export default SignUpPage;
